import { render, staticRenderFns } from "./Log.Detail.vue?vue&type=template&id=4b454765&"
import script from "./Log.Detail.vue?vue&type=script&lang=js&"
export * from "./Log.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports